// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__8aBay","content":"not-allowed_content__3UDt+","title":"not-allowed_title__bnq2d"};